import React, { useState } from "react";

import ModalWrapper from "./ModalWrapper";
import { HandleUploadParams, LayoutType } from "./@types";
import { LAYOUT_TYPE } from "./file-analysis-form/utils";
import FileAnalysisForm from "./file-analysis-form/FileAnalysisForm";

type FileAnalysisModalProps = {
  showModal: boolean;
  closeModal: () => void;
  handleUpload: (args: HandleUploadParams) => void;
};

const FileAnalysisModal: React.FC<FileAnalysisModalProps> = ({
  showModal,
  closeModal,
  handleUpload
}) => {
  const [layoutType, setLayoutType] = useState<LayoutType>(LAYOUT_TYPE.XL);

  return (
    <ModalWrapper
      show={showModal}
      title="File Analysis"
      size={layoutType}
      onHide={closeModal}
      className="file-analysis-modal"
    >
      <FileAnalysisForm
        closeModal={closeModal}
        handleUpload={handleUpload}
        onLayout={setLayoutType}
      />
    </ModalWrapper>
  );
};

export default FileAnalysisModal;
